// extracted by mini-css-extract-plugin
module.exports = {"invoiceArea":"invoice_invoiceArea__2kKXw","paymentScheduleArea":"invoice_paymentScheduleArea__39Ytd","loading":"invoice_loading__3KbMg"};